import { CLINICAL_SUMMARY_NAMC_SENTINEL } from '../../../constants';

/**
 * SHER-286: value to emit when the user answers "No" on a smartfield's Yes/No
 * selector (useSelectSmartField).
 *
 * For an ALLERGY field, "No" means "reviewed, no known allergies" — it must
 * record the NAMC sentinel (exactly what the green "No known allergies" button
 * produces), so the Clinical Summary "no known allergies" green state
 * (recomputed server-side from the sentinel, see sherwood-api
 * PatientInvestigation.recomputeClinicalSummary) triggers. A bare `false` is
 * ignored by that recompute, so the intuitive "No" used to leave the summary
 * blank.
 *
 * All other smartfields (diagnosis, treatment, background, ...) keep emitting
 * `false` (the field's "none / not present" value).
 */
export function noAnswerValue(type?: string): false | Array<Record<string, string>> {
    if (type === 'allergy') {
        return [{ allergy: CLINICAL_SUMMARY_NAMC_SENTINEL, 'compo-code': '' }];
    }
    return false;
}
